import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { ConfirmationDialogComponent, ConfirmationDialogData } from '../components/confirmation-dialog/confirmation-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class ConfirmationService {
  constructor(private dialog: MatDialog) {}

  confirm(data: ConfirmationDialogData): Observable<boolean> {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '500px',
      maxWidth: '95vw',
      disableClose: true,
      panelClass: 'confirmation-dialog-panel',
      data
    });

    return dialogRef.afterClosed();
  }

  // Convenience methods for common confirmation types
  confirmDelete(itemName: string, itemType: string = 'item'): Observable<boolean> {
    return this.confirm({
      title: `Delete ${itemType}`,
      message: `Are you sure you want to delete "${itemName}"? This action cannot be undone.`,
      confirmText: 'Delete',
      cancelText: 'Cancel',
      type: 'danger',
      confirmButtonColor: 'warn'
    });
  }

  confirmAction(
    title: string, 
    message: string, 
    confirmText: string = 'Confirm',
    type: 'info' | 'warning' | 'danger' | 'success' = 'info'
  ): Observable<boolean> {
    return this.confirm({
      title,
      message,
      confirmText,
      cancelText: 'Cancel',
      type
    });
  }

  confirmDeactivate(itemName: string, itemType: string = 'item'): Observable<boolean> {
    return this.confirm({
      title: `Deactivate ${itemType}`,
      message: `Are you sure you want to deactivate "${itemName}"?`,
      confirmText: 'Deactivate',
      cancelText: 'Cancel',
      type: 'warning',
      confirmButtonColor: 'accent'
    });
  }

  confirmActivate(itemName: string, itemType: string = 'item'): Observable<boolean> {
    return this.confirm({
      title: `Activate ${itemType}`,
      message: `Are you sure you want to activate "${itemName}"?`,
      confirmText: 'Activate',
      cancelText: 'Cancel',
      type: 'success',
      confirmButtonColor: 'primary'
    });
  }

  confirmSave(hasUnsavedChanges: boolean = true): Observable<boolean> {
    if (!hasUnsavedChanges) {
      return new Observable(observer => {
        observer.next(true);
        observer.complete();
      });
    }

    return this.confirm({
      title: 'Unsaved Changes',
      message: 'You have unsaved changes. Are you sure you want to leave without saving?',
      confirmText: 'Leave without saving',
      cancelText: 'Stay and save',
      type: 'warning',
      confirmButtonColor: 'warn'
    });
  }
}
